export enum SlideGenerationMode{
  ENHANCED="ENHANCED",
  STRICT="STRICT"
}
